import clsx from 'clsx';
import { Loader2 } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

export type MetricsViewMode = 'hiring_goal' | 'date_range';

interface MetricsViewToggleProps {
  value: MetricsViewMode;
  onChange: (value: MetricsViewMode) => void;
  disabled?: boolean;
  /** Shows a small spinner next to the active tab while its data reloads. */
  isPending?: boolean;
}

export function MetricsViewToggle({
  value,
  onChange,
  disabled,
  isPending,
}: MetricsViewToggleProps) {
  return (
    <div
      className="border-fx-neutral-200 flex w-full gap-2 rounded-lg border bg-white p-1"
      role="tablist"
    >
      <button
        type="button"
        role="tab"
        aria-selected={value === 'hiring_goal'}
        onClick={() => onChange('hiring_goal')}
        className={clsx(
          'text-body flex flex-1 items-center justify-center gap-1.5 rounded-lg px-4 py-1 leading-5 font-medium transition-colors',
          value === 'hiring_goal'
            ? 'bg-fx-brand-50 text-fx-brand-600'
            : 'text-fx-neutral-600 hover:bg-fx-brand-50',
        )}
        disabled={disabled}
      >
        <FormattedMessage
          defaultMessage="Hiring goal"
          description="Segmented control: show hiring goal dates and target"
        />
        {isPending && value === 'hiring_goal' && (
          <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden="true" />
        )}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={value === 'date_range'}
        onClick={() => onChange('date_range')}
        className={clsx(
          'text-body flex flex-1 items-center justify-center gap-1.5 rounded-lg px-4 py-1 leading-5 font-medium transition-colors',
          value === 'date_range'
            ? 'bg-fx-brand-50 text-fx-brand-600'
            : 'text-fx-neutral-600 hover:bg-fx-brand-50',
        )}
        disabled={disabled}
      >
        <FormattedMessage
          defaultMessage="Date range"
          description="Segmented control: filter opening metrics by date range"
        />
        {isPending && value === 'date_range' && (
          <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden="true" />
        )}
      </button>
    </div>
  );
}
